import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from "react";

interface Toast {
  id: number;
  tipo: "exito" | "error" | "info";
  mensaje: string;
}

interface ContextoToast {
  mostrar: (mensaje: string, tipo?: Toast["tipo"]) => void;
}

const ContextoToastReact = createContext<ContextoToast | null>(null);

const ESTILOS_TIPO: Record<Toast["tipo"], string> = {
  exito: "bg-exito",
  error: "bg-error",
  info: "bg-principal",
};

export function ProveedorToast({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const mostrar = useCallback(
    (mensaje: string, tipo: Toast["tipo"] = "info") => {
      const id = Date.now() + Math.random();
      setToasts((actuales) => [...actuales, { id, mensaje, tipo }]);
      setTimeout(() => {
        setToasts((actuales) => actuales.filter((t) => t.id !== id));
      }, 4000);
    },
    [],
  );

  return (
    <ContextoToastReact.Provider value={{ mostrar }}>
      {children}
      <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
        {toasts.map((t) => (
          <div
            key={t.id}
            role="alert"
            className={`rounded-lg px-4 py-3 text-sm font-medium text-superficie shadow-lg ${ESTILOS_TIPO[t.tipo]}`}
          >
            {t.mensaje}
          </div>
        ))}
      </div>
    </ContextoToastReact.Provider>
  );
}

export function useToast(): ContextoToast {
  const contexto = useContext(ContextoToastReact);
  if (!contexto)
    throw new Error("useToast debe usarse dentro de ProveedorToast");
  return contexto;
}
